(function (root) {
  'use strict';

  var MAX_ITEMS = 999;
  var GIFT_THRESHOLD = 4;
  var UNIT_PRICE = 3199;

  function normalizeText(value) {
    return String(value == null ? '' : value).normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().replace(/\s+/g, ' ').trim();
  }

  function matchesSearch(searchText, query) {
    var text = normalizeText(searchText);
    var searchable = text.replace(/\b(?:[a-z]\s+){2,}[a-z]\b/g, function (brand) { return brand.replace(/\s/g, ''); });
    return normalizeText(query).split(' ').filter(Boolean).every(function (term) { return text.includes(term) || searchable.includes(term); });
  }

  function matchesFilter(product, filter) {
    if (filter === 'all') return true;
    var gender = normalizeText(product.gender);
    var category = normalizeText(product.category);
    return filter === 'nicho' ? category.includes('nicho') || category.includes('alta gama') : gender === filter;
  }

  function clampQuantity(value, maximum) {
    var parsed = Number(value);
    return Number.isFinite(parsed) ? Math.min(maximum == null ? MAX_ITEMS : maximum, Math.max(0, Math.floor(parsed))) : 0;
  }

  function variantId(value) {
    var id = String(value == null ? '' : value).split('/').pop();
    return /^[1-9]\d*$/.test(id) ? id : '';
  }

  function dedupeProducts(groups) {
    var seen = new Map();
    var products = [];
    function updateSearch(product) {
      product.searchText = normalizeText([product.title, product.inspiration, product.handle, product.gender, product.category, Array.isArray(product.tags) ? product.tags.join(' ') : product.tags].filter(Boolean).join(' '));
    }
    groups.forEach(function (group) {
      var rows = Array.isArray(group) ? group : group && Array.isArray(group.products) ? group.products : [];
      rows.forEach(function (raw) {
        if (!raw || typeof raw !== 'object') return;
        var id = variantId(raw.variantId);
        var cents = Number(raw.price == null ? raw.pricecents : raw.price);
        if (!id || cents !== UNIT_PRICE) return;
        if (seen.has(id)) {
          var existing = seen.get(id);
          existing.available = existing.available === true && raw.available === true;
          var genders = normalizeText([existing.gender, raw.gender].filter(Boolean).join(' '));
          existing.gender = genders.includes('unisex') || (genders.includes('hombre') && genders.includes('mujer')) ? 'unisex' : genders.includes('hombre') ? 'hombre' : genders.includes('mujer') ? 'mujer' : existing.gender || raw.gender || '';
          var categories = normalizeText([existing.category, raw.category].filter(Boolean).join(' '));
          existing.category = categories.includes('nicho') || categories.includes('alta gama') ? 'nicho' : existing.category || raw.category || '';
          var oldTags = Array.isArray(existing.tags) ? existing.tags : existing.tags ? [existing.tags] : [];
          var newTags = Array.isArray(raw.tags) ? raw.tags : raw.tags ? [raw.tags] : [];
          existing.tags = Array.from(new Set(oldTags.concat(newTags)));
          if (!existing.inspiration && raw.inspiration) existing.inspiration = raw.inspiration;
          updateSearch(existing);
          return;
        }
        var product = Object.assign({}, raw, { variantId: id, price: cents, title: String(raw.title || ''), available: raw.available === true });
        updateSearch(product);
        seen.set(id, product);
        products.push(product);
      });
    });
    return products.sort(function (a, b) { return Number(b.available) - Number(a.available); });
  }

  function sanitizeSelection(entries, products, maximum) {
    var available = new Set(products.filter(function (product) { return product.available === true; }).map(function (product) { return product.variantId; }));
    var result = [];
    if (!Array.isArray(entries)) return result;
    entries.forEach(function (entry) {
      var id = variantId(entry && typeof entry === 'object' ? entry.variantId : entry);
      var quantity = entry && typeof entry === 'object' ? clampQuantity(entry.quantity, maximum) : 1;
      if (!available.has(id)) return;
      for (var i = 0; i < quantity && result.length < (maximum || MAX_ITEMS); i += 1) result.push(id);
    });
    return result;
  }

  function calculatePricing(quantity, config) {
    var count = clampQuantity(quantity);
    var configuredRate = config && typeof config.promoOrderRate7 === 'number' ? config.promoOrderRate7 : config && config.promoOrderRate6;
    var rate = typeof configuredRate === 'number' && Number.isFinite(configuredRate) && configuredRate >= 0 && configuredRate <= 1 ? configuredRate : 0.3751;
    var adjustment = config && typeof config.promoAdjustment === 'number' && Number.isFinite(config.promoAdjustment) ? Math.max(0, Math.floor(config.promoAdjustment)) : 1;
    var grossPaid = count >= 7 ? (count - 1) * UNIT_PRICE : 0;
    var total = count >= 7 ? grossPaid - Math.min(grossPaid, Math.floor(grossPaid * rate) + adjustment) : count >= GIFT_THRESHOLD ? (count - 1) * 2333 : [0, 3199, 5398, 6999][count];
    var original = count * UNIT_PRICE;
    var giftSavings = count >= GIFT_THRESHOLD ? UNIT_PRICE : 0;
    return {
      quantity: count,
      original: original,
      total: total,
      savings: original - total,
      regularSavings: original - total - giftSavings,
      giftSavings: giftSavings,
      giftCount: count >= GIFT_THRESHOLD ? 1 : 0,
      paidUnitPrice: count >= 7 ? 1999 : count === 1 ? 3199 : count === 2 ? 2699 : count >= 3 ? 2333 : 0
    };
  }

  function isExpired(endAt, now) {
    var end = Date.parse(endAt);
    return !Number.isFinite(end) || (now == null ? Date.now() : Number(now)) >= end;
  }

  function groupedSelection(selection) {
    var rows = [];
    var byId = new Map();
    selection.forEach(function (id) {
      if (!byId.has(id)) {
        var row = { variantId: id, quantity: 0 };
        byId.set(id, row);
        rows.push(row);
      }
      byId.get(id).quantity += 1;
    });
    return rows;
  }

  function allocateLineTotals(selection, pricing) {
    var rows = groupedSelection(selection);
    var giftVariant = pricing.giftCount ? selection[GIFT_THRESHOLD - 1] : null;
    var paidCount = pricing.quantity - pricing.giftCount;
    var lastPaidIndex = -1;
    rows.forEach(function (row, index) {
      row.giftQuantity = row.variantId === giftVariant ? 1 : 0;
      row.paidQuantity = row.quantity - row.giftQuantity;
      if (row.paidQuantity) lastPaidIndex = index;
    });
    var remaining = pricing.total;
    rows.forEach(function (row, index) {
      row.lineTotal = !row.paidQuantity ? 0 : index === lastPaidIndex ? remaining : Math.floor(pricing.total * row.paidQuantity / paidCount);
      remaining -= row.lineTotal;
    });
    return rows;
  }

  function parseCatalogResponse(html, Parser) {
    if (typeof Parser !== 'function') throw new Error('Catalog parser unavailable');
    var parsed = new Parser().parseFromString(html, 'text/html');
    var nodes = Array.from(parsed.querySelectorAll('.lsp-promo-data-collection'));
    var configNode = parsed.getElementById('lsp-promo-config');
    if (!nodes.length || !configNode) throw new Error('Catalog response incomplete');
    var groups = nodes.map(function (node) {
      var group = JSON.parse(node.textContent);
      if (!Array.isArray(group) && !(group && Array.isArray(group.products))) throw new Error('Invalid catalog collection');
      return group;
    });
    var freshConfig = JSON.parse(configNode.textContent);
    if (!freshConfig || typeof freshConfig !== 'object' || Array.isArray(freshConfig) || !Number.isFinite(Date.parse(freshConfig.endAt))) throw new Error('Invalid catalog configuration');
    return { products: dedupeProducts(groups), config: freshConfig };
  }

  async function fetchCatalogSnapshot(config, origin, fetcher, Parser) {
    if (!config || !config.catalogUrl || !config.sectionId || typeof fetcher !== 'function') throw new Error('Catalog refresh unavailable');
    var url = new URL(config.catalogUrl, origin);
    if (url.origin !== origin) throw new Error('Catalog origin mismatch');
    url.searchParams.set('section_id', config.sectionId);
    url.searchParams.set('_lsp_catalog', String(Date.now()));
    var controller = typeof root.AbortController === 'function' ? new root.AbortController() : null;
    var options = { credentials: 'same-origin', cache: 'no-store' };
    if (controller) options.signal = controller.signal;
    var timer;
    try {
      var request = fetcher(url.toString(), options);
      if (typeof root.setTimeout === 'function') request = Promise.race([request, new Promise(function (_, reject) {
        timer = root.setTimeout(function () { if (controller) controller.abort(); reject(new Error('Catalog refresh timed out')); }, 8000);
      })]);
      var response = await request;
      if (!response || !response.ok || response.url && new URL(response.url).origin !== origin) throw new Error('Catalog refresh failed');
      return parseCatalogResponse(await response.text(), Parser);
    } finally {
      if (timer && typeof root.clearTimeout === 'function') root.clearTimeout(timer);
    }
  }

  function reconcileSelection(selection, products) {
    var next = sanitizeSelection(selection, products);
    return { selection: next, lost: next.length !== selection.length };
  }

  function catalogSignature(products) {
    return JSON.stringify(products.map(function (product) { return [product.variantId, product.price, product.available, product.title, product.image, product.gender, product.category, product.tags, product.inspiration, product.url, product.handle]; }));
  }

  function selectionSignature(selection) {
    return groupedSelection(selection).sort(function (a, b) { return a.variantId.localeCompare(b.variantId); }).map(function (row) { return row.variantId + ':' + row.quantity; }).join(',');
  }

  function buildCheckoutUrl(selection, config, origin, now) {
    if (!config || config.checkoutEnabled !== true || isExpired(config.endAt, now)) return null;
    if (!Array.isArray(selection) || selection.length < 1 || selection.length > MAX_ITEMS || selection.some(function (id) { return !variantId(id); })) return null;
    var count = selection.length;
    if (count === 3) return null;
    var codes = count >= 7 ? config.promoCodes7 : count === 6 ? config.promoCodes6 : count === 5 ? config.promoCodes5 : count === GIFT_THRESHOLD ? Array.isArray(config.promoCodes) ? config.promoCodes : [config.promoCode] : count === 3 ? [config.normalCode3] : count === 2 ? [config.normalCode2] : [];
    if (count > 1 && (!Array.isArray(codes) || !codes.length || codes.some(function (value) { return typeof value !== 'string' || !value.trim() || value.includes(','); }))) return null;
    var code = codes.map(function (value) { return value.trim(); }).join(',');
    var items = groupedSelection(selection.map(variantId)).map(function (row) { return row.variantId + ':' + row.quantity; }).join(',');
    var url = new URL('/cart/' + items, origin);
    if (code) url.searchParams.set('discount', code);
    url.searchParams.set('attributes[promocion]', '3+1 · Promo');
    return url.toString();
  }

  var api = { normalizeText: normalizeText, matchesSearch: matchesSearch, matchesFilter: matchesFilter, clampQuantity: clampQuantity, variantId: variantId, dedupeProducts: dedupeProducts, sanitizeSelection: sanitizeSelection, calculatePricing: calculatePricing, isExpired: isExpired, groupedSelection: groupedSelection, allocateLineTotals: allocateLineTotals, parseCatalogResponse: parseCatalogResponse, fetchCatalogSnapshot: fetchCatalogSnapshot, reconcileSelection: reconcileSelection, selectionSignature: selectionSignature, buildCheckoutUrl: buildCheckoutUrl };
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
  root.LSPPromo = api;
  if (!root.document) return;

  function boot() {
    var document = root.document;
    var host = document.getElementById('lsp-promo-root');
    var configNode = document.getElementById('lsp-promo-config');
    if (!host || !configNode || host.dataset.lspInitialized === 'true') return;
    host.dataset.lspInitialized = 'true';
    var config;
    try { config = JSON.parse(configNode.textContent); } catch (_) { return; }
    var labels = Object.assign({
      stockUrgency: 'Ya hay {count} perfumes agotados. Elige los tuyos antes del cierre.',
      catalogUpdated: 'El catálogo ha cambiado. Revisa tu selección y elige de nuevo los perfumes que ya no están disponibles.',
      catalogUnavailable: 'No hemos podido comprobar el catálogo. Reintenta finalizar en unos segundos.',
      offerContinueOne: 'Continuar con 1 perfume',
      offerContinueTwo: 'Continuar con 2 perfumes',
      add: 'Añadir', addAnother: 'Añadir otro', soldOut: 'Agotado', remove: 'Quitar', decrease: 'Quitar una unidad de {title}', increase: 'Añadir una unidad de {title}', quantity: 'Cantidad de {title}', gift: 'GRATIS', giftLine: '{paid} de pago + 1 GRATIS', results: '{count} perfumes', result: '1 perfume', noResults: 'No encontramos ese perfume. Prueba otro nombre.', message0: 'Elige 4 perfumes. Paga solo 69,99 €.', message1: 'Te faltan 3 para llevarte uno GRATIS.', message2: 'Añade 2 más: llévate 4 por 69,99 €.', message3: 'Añade el cuarto GRATIS. Seguirás pagando 69,99 €.', message4: 'Tu perfume GRATIS ya está incluido.', message5: 'Cada perfume adicional cuesta 23,33 €.', maxItems: 'Has alcanzado el máximo de unidades permitido.', expired: 'Esta promoción ha terminado.', draft: 'Borrador: el pago está desactivado hasta validar la promoción.', checkout: 'Finalizar compra', checkoutDraft: 'Pago pendiente de validación', checkoutEmpty: 'Elige tus perfumes', checkoutExpired: 'Promoción finalizada', checkoutUnavailable: 'Esta selección no tiene un descuento validado.', checkoutChooseGift: 'Elegir mi perfume gratis', chooseGiftNotice: 'Te falta elegir tu cuarto perfume GRATIS para finalizar y aprovechar el 4x3.', productUnavailable: 'Este perfume no está disponible.', noCatalog: 'No hay perfumes disponibles para esta promoción.', giftBreakdown: '1 perfume de regalo', checkoutPreparing: 'Preparando tu compra…', added: 'Perfume añadido. {count} en tu selección.', addedWithGift: 'Perfume añadido. Tu regalo sigue incluido.', mobileAction: 'Ver selección'
    }, config.labels || {});
    var catalogGroups = [];
    var catalogScope = host.closest('.shopify-section') || document;
    catalogScope.querySelectorAll('.lsp-promo-data-collection').forEach(function (node) {
      try { catalogGroups.push(JSON.parse(node.textContent)); } catch (_) {}
    });
    var products = dedupeProducts(catalogGroups);
    var byVariant = new Map(products.map(function (product) { return [product.variantId, product]; }));
    var nodes = {};
    ['search', 'products', 'results-count', 'empty-search', 'cart', 'cart-items', 'cart-empty', 'cart-count', 'message', 'original-total', 'savings', 'total', 'regular-savings', 'gift-savings', 'gift-detail', 'checkout', 'status', 'expiry', 'mobile-total', 'mobile-count', 'mobile-action', 'toast', 'low-quantity'].forEach(function (name) {
      nodes[name] = document.getElementById('lsp-promo-' + name);
    });
    var selection = [];
    var filter = 'all';
    var query = nodes.search ? nodes.search.value : '';
    var closed = isExpired(config.endAt);
    var storageKey = 'lsp-promo:' + (config.version || '2026-10-3plus1') + ':' + config.endAt;
    var currency = config.currency || 'EUR';
    var formatter = new Intl.NumberFormat('es-ES', { style: 'currency', currency: currency });
    var countdownTimer;
    var toastTimer;
    var quantityTimer;
    var catalogTimer;
    var refreshInFlight;
    var checkingCheckout = false;
    var disposed = false;
    var cartIsOpen = false;
    var cartTrigger;
    var lowQuantityIsOpen = false;
    var lowQuantityTrigger;
    var offeredSignature = '';
    var acknowledgedOffers = new Set();
    var mobileMedia = root.matchMedia('(max-width: 760px)');

    function label(key, values) {
      var value = String(labels[key] || '');
      Object.keys(values || {}).forEach(function (name) { value = value.split('{' + name + '}').join(String(values[name])).split('[' + name + ']').join(String(values[name])); });
      return value;
    }

    function money(cents) { return formatter.format(cents / 100); }

    function setText(node, text) { if (node) node.textContent = text; }

    function announce(text) { setText(nodes.status, text); }

    function updateStockSummary() {
      var unavailableCount = products.filter(function (product) { return product.available === false; }).length;
      host.querySelectorAll('[data-lsp-stock-summary]').forEach(function (node) {
        node.hidden = unavailableCount === 0;
        setText(node, label('stockUrgency', { count: unavailableCount }));
      });
    }
    updateStockSummary();

    async function refreshCatalog() {
      if (disposed) return { ok: false, lost: false };
      if (!refreshInFlight) refreshInFlight = fetchCatalogSnapshot(config, root.location.origin, typeof root.fetch === 'function' ? root.fetch.bind(root) : null, root.DOMParser).then(function (snapshot) {
        if (disposed) return { ok: false, lost: false };
        snapshot.config.catalogUrl = config.catalogUrl;
        snapshot.config.sectionId = config.sectionId;
        var changed = catalogSignature(products) !== catalogSignature(snapshot.products) || JSON.stringify(config) !== JSON.stringify(snapshot.config);
        var reconciled = reconcileSelection(selection, snapshot.products);
        products = snapshot.products;
        byVariant = new Map(products.map(function (product) { return [product.variantId, product]; }));
        config = snapshot.config;
        Object.assign(labels, config.labels || {});
        closed = isExpired(config.endAt);
        selection = closed ? [] : reconciled.selection;
        if (changed || reconciled.lost) {
          if (quantityTimer && typeof root.clearTimeout === 'function') root.clearTimeout(quantityTimer);
          renderProducts();
          renderCart();
          updateStockSummary();
          updateCountdown();
        }
        if (reconciled.lost) {
          announce(label('catalogUpdated'));
          showNotice(label('catalogUpdated'), 5000);
        }
        return { ok: true, lost: reconciled.lost, changed: changed };
      }).catch(function () { return { ok: false, lost: false }; }).finally(function () { refreshInFlight = null; });
      return refreshInFlight;
    }

    function focus(node) { if (node && typeof node.focus === 'function') node.focus(); }

    function setCartOpen(open, trigger) {
      if (!nodes.cart) return;
      if (open && !mobileMedia.matches) {
        if (typeof nodes.cart.scrollIntoView === 'function') nodes.cart.scrollIntoView({ behavior: root.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
        return;
      }
      cartIsOpen = Boolean(open);
      if (cartIsOpen) cartTrigger = trigger || document.activeElement;
      host.classList.toggle('is-cart-open', cartIsOpen);
      nodes.cart.classList.toggle('is-mobile-open', cartIsOpen);
      if (document.body) document.body.classList.toggle('lsp-promo-cart-open', cartIsOpen || lowQuantityIsOpen);
      nodes.cart.setAttribute('aria-hidden', String(mobileMedia.matches && !cartIsOpen));
      if (cartIsOpen) {
        nodes.cart.setAttribute('role', 'dialog');
        nodes.cart.setAttribute('aria-modal', 'true');
      } else if (typeof nodes.cart.removeAttribute === 'function') {
        nodes.cart.removeAttribute('role');
        nodes.cart.removeAttribute('aria-modal');
      }
      host.querySelectorAll('[data-lsp-open-cart]').forEach(function (button) { button.setAttribute('aria-expanded', String(cartIsOpen)); });
      host.querySelectorAll('.lsp-promo__cart-overlay').forEach(function (overlay) { overlay.hidden = !cartIsOpen; });
      if (cartIsOpen) focus(nodes.cart.querySelectorAll('[data-lsp-close-cart]')[0]);
      else focus(cartTrigger);
    }

    function setLowQuantityOpen(open, trigger) {
      if (!nodes['low-quantity']) return false;
      lowQuantityIsOpen = Boolean(open);
      if (lowQuantityIsOpen) {
        lowQuantityTrigger = trigger || document.activeElement;
        offeredSignature = selectionSignature(selection);
        host.querySelectorAll('[data-lsp-offer-continue]').forEach(function (button) { setText(button, label(selection.length === 1 ? 'offerContinueOne' : 'offerContinueTwo')); });
      }
      nodes['low-quantity'].hidden = !lowQuantityIsOpen;
      nodes['low-quantity'].setAttribute('aria-hidden', String(!lowQuantityIsOpen));
      host.classList.toggle('is-offer-open', lowQuantityIsOpen);
      if (document.body) document.body.classList.toggle('lsp-promo-cart-open', cartIsOpen || lowQuantityIsOpen);
      if (nodes.cart) {
        nodes.cart.setAttribute('aria-hidden', String(lowQuantityIsOpen || mobileMedia.matches && !cartIsOpen));
        if (cartIsOpen) nodes.cart.setAttribute('aria-modal', String(!lowQuantityIsOpen));
      }
      if (lowQuantityIsOpen) focus(nodes['low-quantity'].querySelectorAll('[data-lsp-offer-add]')[0]);
      else focus(lowQuantityTrigger);
      return true;
    }

    function acknowledgeLowQuantity() {
      if (offeredSignature) acknowledgedOffers.add(offeredSignature);
      setLowQuantityOpen(false);
      persist();
    }

    function showNotice(text, duration) {
      if (!nodes.toast) return;
      if (toastTimer && typeof root.clearTimeout === 'function') root.clearTimeout(toastTimer);
      setText(nodes.toast, text);
      nodes.toast.classList.toggle('is-visible', true);
      if (typeof root.setTimeout === 'function') toastTimer = root.setTimeout(function () { nodes.toast.classList.toggle('is-visible', false); }, duration || 2000);
    }

    function showAdded(product) {
      var key = selection.length >= GIFT_THRESHOLD ? 'addedWithGift' : 'added';
      var text = label(key, { count: selection.length, title: product.title });
      if (!String(labels[key]).includes('{title}') && !String(labels[key]).includes('[title]')) text = product.title + ' · ' + text;
      showNotice(text, 2000);
    }

    function persist() {
      try {
        if (closed) root.sessionStorage.removeItem(storageKey);
        else root.sessionStorage.setItem(storageKey, JSON.stringify({ endAt: config.endAt, selection: selection, acknowledgedOffers: Array.from(acknowledgedOffers) }));
      } catch (_) {}
    }

    if (!closed) {
      try {
        var restored = JSON.parse(root.sessionStorage.getItem(storageKey) || 'null');
        if (restored && restored.endAt === config.endAt) {
          selection = sanitizeSelection(restored.selection, products);
          if (Array.isArray(restored.acknowledgedOffers)) acknowledgedOffers = new Set(restored.acknowledgedOffers.filter(function (value) { return typeof value === 'string'; }));
        }
      } catch (_) {}
    } else persist();

    function createElement(tag, className, content) {
      var node = document.createElement(tag);
      if (className) node.className = className;
      if (content != null) node.textContent = content;
      return node;
    }

    function createImage(product) {
      var image = document.createElement('img');
      image.alt = product.title;
      image.loading = 'lazy';
      image.decoding = 'async';
      image.width = 320;
      image.height = 400;
      if (product.image) image.src = product.image;
      return image;
    }

    function renderProducts() {
      if (!nodes.products) return;
      var filtered = products.filter(function (product) {
        return matchesFilter(product, filter) && matchesSearch(product.searchText, query);
      });
      var fragment = document.createDocumentFragment();
      filtered.forEach(function (product) {
        var card = createElement('article', 'lsp-card' + (product.available ? '' : ' is-sold-out'));
        var imageWrap = createElement('div', 'lsp-card__image-wrap');
        imageWrap.appendChild(createImage(product));
        var body = createElement('div', 'lsp-card__body');
        body.appendChild(createElement('h3', 'lsp-card__title', product.title));
        if (product.inspiration) body.appendChild(createElement('p', 'lsp-card__subtitle', product.inspiration));
        body.appendChild(createElement('p', 'lsp-card__price', money(product.price)));
        var add = createElement('button', 'lsp-card__add', label(product.available ? 'add' : 'soldOut'));
        add.type = 'button';
        add.dataset.lspAdd = product.variantId;
        add.disabled = closed || !product.available || selection.length >= MAX_ITEMS;
        add.setAttribute('aria-label', product.available ? label('increase', { title: product.title }) : product.title + ' · ' + label('soldOut'));
        body.appendChild(add);
        card.append(imageWrap, body);
        fragment.appendChild(card);
      });
      nodes.products.replaceChildren(fragment);
      setText(nodes['results-count'], filtered.length === 1 ? label('result') : label('results', { count: filtered.length }));
      if (nodes['empty-search']) {
        nodes['empty-search'].hidden = filtered.length !== 0;
        setText(nodes['empty-search'], products.length === 0 ? label('noCatalog') : label('noResults'));
      }
    }

    function updateAddButtons() {
      host.querySelectorAll('[data-lsp-add]').forEach(function (button) {
        var product = byVariant.get(button.dataset.lspAdd);
        button.disabled = closed || !product || !product.available || selection.length >= MAX_ITEMS;
      });
    }

    function renderCart() {
      var price = calculatePricing(selection.length, config);
      if (lowQuantityIsOpen && (closed || selectionSignature(selection) !== offeredSignature)) setLowQuantityOpen(false);
      if (nodes['cart-items']) {
        var fragment = document.createDocumentFragment();
        allocateLineTotals(selection, price).forEach(function (row) {
          var product = byVariant.get(row.variantId);
          var hasGift = row.giftQuantity > 0;
          var paidQuantity = row.paidQuantity;
          var item = createElement('div', 'lsp-cart-item' + (hasGift ? ' is-gift' : ''));
          item.appendChild(createImage(product));
          var info = createElement('div', 'lsp-cart-item__info');
          info.appendChild(createElement('p', 'lsp-cart-item__title', product.title));
          if (hasGift) info.appendChild(createElement('span', 'lsp-gift-badge', label('gift')));
          info.appendChild(createElement('p', 'lsp-cart-item__price', hasGift && row.quantity > 1 ? label('giftLine', { paid: paidQuantity }) + ' · ' + money(row.lineTotal) : money(row.lineTotal)));
          var controls = createElement('div', 'lsp-cart-item__quantity');
          var less = createElement('button', '', '−');
          less.type = 'button';
          less.dataset.lspDecrease = row.variantId;
          less.setAttribute('aria-label', label('decrease', { title: product.title }));
          less.disabled = closed;
          var input = createElement('input');
          input.type = 'number';
          input.min = '1';
          input.max = String(MAX_ITEMS - selection.length + row.quantity);
          input.step = '1';
          input.value = String(row.quantity);
          input.inputMode = 'numeric';
          input.dataset.lspQuantity = row.variantId;
          input.setAttribute('aria-label', label('quantity', { title: product.title }));
          input.disabled = closed;
          var more = createElement('button', '', '+');
          more.type = 'button';
          more.dataset.lspIncrease = row.variantId;
          more.setAttribute('aria-label', label('increase', { title: product.title }));
          more.disabled = closed || selection.length >= MAX_ITEMS;
          controls.append(less, input, more);
          info.appendChild(controls);
          var remove = createElement('button', 'lsp-cart-item__remove', label('remove'));
          remove.type = 'button';
          remove.dataset.lspRemove = row.variantId;
          remove.disabled = closed;
          info.appendChild(remove);
          item.appendChild(info);
          fragment.appendChild(item);
        });
        nodes['cart-items'].replaceChildren(fragment);
      }
      if (nodes['cart-empty']) nodes['cart-empty'].hidden = selection.length !== 0;
      setText(nodes['cart-count'], String(price.quantity));
      setText(nodes['mobile-count'], String(price.quantity));
      setText(nodes['original-total'], money(price.original));
      setText(nodes.savings, money(price.savings));
      setText(nodes.total, money(price.total));
      setText(nodes['mobile-total'], money(price.total));
      setText(nodes['regular-savings'], money(price.regularSavings));
      setText(nodes['gift-savings'], money(price.giftSavings));
      if (nodes['gift-detail']) nodes['gift-detail'].hidden = price.giftCount === 0;
      setText(nodes.message, closed ? label('expired') : price.quantity === 5 ? label('message5') : label('message' + Math.min(price.quantity, GIFT_THRESHOLD)));
      setText(nodes['mobile-action'], label('mobileAction'));
      host.querySelectorAll('[data-lsp-mobile-summary]').forEach(function (summary) { summary.hidden = closed; });
      var progressKey = 'progress' + Math.min(price.quantity, GIFT_THRESHOLD);
      var progress = closed ? label('expired') : config.labels && config.labels[progressKey] ? label(progressKey) : label('message' + Math.min(price.quantity, GIFT_THRESHOLD));
      host.querySelectorAll('[data-lsp-mobile-progress]').forEach(function (node) { setText(node, progress); });
      if (!price.quantity || closed) setCartOpen(false);
      var checkout = buildCheckoutUrl(selection, config, root.location.origin);
      var needsGift = price.quantity === 3 && !closed;
      if (nodes.checkout) {
        nodes.checkout.disabled = checkingCheckout || !checkout && !(needsGift && config.checkoutEnabled === true);
        setText(nodes.checkout, checkingCheckout ? label('checkoutPreparing') : closed ? label('checkoutExpired') : config.checkoutEnabled !== true ? label('checkoutDraft') : !selection.length ? label('checkoutEmpty') : needsGift ? label('checkoutChooseGift') : label('checkout'));
      }
      if (closed) announce(label('expired'));
      else if (config.checkoutEnabled !== true) announce(label('draft'));
      else if (needsGift) announce(label('chooseGiftNotice'));
      else if (selection.length && !checkout) announce(label('checkoutUnavailable'));
      else announce('');
      updateAddButtons();
      persist();
    }

    function addProduct(id) {
      if (closed) return;
      if (!byVariant.has(id) || !byVariant.get(id).available) { announce(label('productUnavailable')); return; }
      if (selection.length >= MAX_ITEMS) { announce(label('maxItems')); return; }
      selection.push(id);
      renderCart();
      showAdded(byVariant.get(id));
    }

    function decreaseProduct(id) {
      if (closed) return;
      var index = selection.lastIndexOf(id);
      if (index >= 0) selection.splice(index, 1);
      renderCart();
    }

    function updateCountdown() {
      var end = Date.parse(config.endAt);
      var remaining = Number.isFinite(end) ? Math.max(0, end - Date.now()) : 0;
      var minutes = Math.ceil(remaining / 60000);
      var values = { days: Math.floor(minutes / 1440), hours: Math.floor(minutes % 1440 / 60), minutes: minutes % 60 };
      Object.keys(values).forEach(function (name) {
        host.querySelectorAll('[data-countdown="' + name + '"]').forEach(function (node) { setText(node, String(values[name]).padStart(2, '0')); });
      });
      if (!remaining) {
        if (!closed) {
          closed = true;
          selection = [];
          renderCart();
          renderProducts();
        }
        if (nodes.expiry) setText(nodes.expiry, label('expired'));
        if (countdownTimer) root.clearInterval(countdownTimer);
      }
    }

    async function finalizeCheckout() {
      if (checkingCheckout) return;
      if (isExpired(config.endAt)) { closed = true; selection = []; renderCart(); return; }
      if (selection.length === 3 && config.checkoutEnabled === true) {
        var notice = label('chooseGiftNotice');
        setCartOpen(false);
        announce(notice);
        showNotice(notice, 5000);
        focus(nodes.search);
        if (nodes.search && typeof nodes.search.scrollIntoView === 'function') nodes.search.scrollIntoView({ behavior: root.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'center' });
        return;
      }
      if (config.checkoutEnabled !== true || !selection.length) { renderCart(); return; }
      if (selection.length <= 2 && !acknowledgedOffers.has(selectionSignature(selection)) && setLowQuantityOpen(true, nodes.checkout)) return;
      var checkoutSelection = selection.join(',');
      checkingCheckout = true;
      renderCart();
      var refreshed = await refreshCatalog();
      checkingCheckout = false;
      if (!refreshed.ok || refreshed.lost || checkoutSelection !== selection.join(',') || closed) {
        renderCart();
        var failure = closed ? label('expired') : refreshed.ok ? label('catalogUpdated') : label('catalogUnavailable');
        announce(failure);
        showNotice(failure, 5000);
        if (refreshed.lost) { setCartOpen(false); focus(nodes.search); }
        return;
      }
      var destination = buildCheckoutUrl(selection, config, root.location.origin);
      if (!destination) { renderCart(); return; }
      nodes.checkout.disabled = true;
      setText(nodes.checkout, label('checkoutPreparing'));
      root.location.assign(destination);
    }

    host.addEventListener('click', async function (event) {
      var button = event.target.closest('button');
      if (!button || !host.contains(button)) return;
      if (button.dataset.lspAdd) addProduct(button.dataset.lspAdd);
      else if (button.dataset.lspIncrease) addProduct(button.dataset.lspIncrease);
      else if (button.dataset.lspDecrease) decreaseProduct(button.dataset.lspDecrease);
      else if (button.dataset.lspRemove) {
        if (closed) return;
        selection = selection.filter(function (id) { return id !== button.dataset.lspRemove; });
        renderCart();
      } else if (button.dataset.filter) {
        filter = button.dataset.filter;
        host.querySelectorAll('[data-filter]').forEach(function (filterButton) {
          var active = filterButton.dataset.filter === filter;
          filterButton.setAttribute('aria-pressed', String(active));
          filterButton.classList.toggle('is-active', active);
        });
        renderProducts();
      } else if (button.hasAttribute('data-lsp-open-cart')) {
        setCartOpen(!cartIsOpen, button);
      } else if (button.hasAttribute('data-lsp-close-cart')) {
        setCartOpen(false);
      } else if (button.hasAttribute('data-lsp-offer-close')) {
        acknowledgeLowQuantity();
      } else if (button.hasAttribute('data-lsp-offer-add')) {
        acknowledgeLowQuantity();
        setCartOpen(false);
        focus(nodes.search);
        announce(label('message' + Math.min(selection.length, GIFT_THRESHOLD)));
        if (nodes.search && typeof nodes.search.scrollIntoView === 'function') nodes.search.scrollIntoView({ behavior: root.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'center' });
      } else if (button.hasAttribute('data-lsp-offer-continue')) {
        acknowledgeLowQuantity();
        await finalizeCheckout();
      } else if (button === nodes.checkout) {
        await finalizeCheckout();
      }
    });

    function updateQuantity(input) {
      if (!input.dataset.lspQuantity || closed) return;
      if (quantityTimer && typeof root.clearTimeout === 'function') root.clearTimeout(quantityTimer);
      var id = input.dataset.lspQuantity;
      if (!byVariant.has(id) || !byVariant.get(id).available) return;
      var wasFocused = document.activeElement === input;
      var current = selection.filter(function (item) { return item === id; }).length;
      var wanted = clampQuantity(input.value, MAX_ITEMS - selection.length + current);
      if (wanted === current) { input.value = String(current); return; }
      while (current > wanted) {
        selection.splice(selection.lastIndexOf(id), 1);
        current -= 1;
      }
      while (current < wanted && selection.length < MAX_ITEMS) {
        selection.push(id);
        current += 1;
      }
      renderCart();
      if (wasFocused) focus(host.querySelectorAll('[data-lsp-quantity="' + id + '"]')[0]);
    }

    host.addEventListener('change', function (event) { updateQuantity(event.target); });
    host.addEventListener('focusout', function (event) { updateQuantity(event.target); });
    host.addEventListener('input', function (event) {
      var input = event.target;
      if (!input.dataset.lspQuantity || closed || input.value === '') return;
      if (quantityTimer && typeof root.clearTimeout === 'function') root.clearTimeout(quantityTimer);
      if (typeof root.setTimeout === 'function') quantityTimer = root.setTimeout(function () { updateQuantity(input); }, 250);
    });
    host.addEventListener('keydown', function (event) {
      if (event.key !== 'Enter' || !event.target.dataset.lspQuantity) return;
      event.preventDefault();
      updateQuantity(event.target);
    });

    if (nodes.search) nodes.search.addEventListener('input', function () { query = nodes.search.value; renderProducts(); });
    document.addEventListener('keydown', function (event) {
      var dialog = lowQuantityIsOpen ? nodes['low-quantity'] : cartIsOpen ? nodes.cart : null;
      if (!dialog) return;
      if (event.key === 'Escape') {
        event.preventDefault();
        if (lowQuantityIsOpen) acknowledgeLowQuantity();
        else setCartOpen(false);
      } else if (event.key === 'Tab') {
        var focusable = Array.from(dialog.querySelectorAll('button, input, select, textarea, a[href], [tabindex]')).filter(function (node) { return !node.disabled && node.tabIndex !== -1 && !node.hidden && (typeof node.getClientRects !== 'function' || node.getClientRects().length > 0); });
        var first = focusable[0];
        var last = focusable[focusable.length - 1];
        if (!first) { event.preventDefault(); return; }
        if (event.shiftKey && (document.activeElement === first || !dialog.contains(document.activeElement))) {
          event.preventDefault();
          focus(last);
        } else if (!event.shiftKey && (document.activeElement === last || !dialog.contains(document.activeElement))) {
          event.preventDefault();
          focus(first);
        }
      }
    });
    if (typeof mobileMedia.addEventListener === 'function') mobileMedia.addEventListener('change', function () { setCartOpen(false); });
    root.addEventListener('pageshow', function (event) { closed = isExpired(config.endAt); if (closed) selection = []; updateCountdown(); renderCart(); if (event.persisted && !closed) refreshCatalog(); });
    document.addEventListener('visibilitychange', function () { if (document.visibilityState !== 'hidden' && !closed) refreshCatalog(); });
    renderProducts();
    renderCart();
    updateCountdown();
    if (!closed) countdownTimer = root.setInterval(updateCountdown, 15000);
    catalogTimer = root.setInterval(function () { if (!closed && document.visibilityState !== 'hidden') refreshCatalog(); }, 60000);
    document.addEventListener('shopify:section:unload', function (event) {
      if (event.target.contains(host)) {
        disposed = true;
        root.clearInterval(countdownTimer);
        root.clearInterval(catalogTimer);
        if (typeof root.clearTimeout === 'function') root.clearTimeout(toastTimer);
        if (typeof root.clearTimeout === 'function') root.clearTimeout(quantityTimer);
        setLowQuantityOpen(false);
        setCartOpen(false);
      }
    });
  }

  if (root.document.readyState === 'loading') root.document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();
  root.document.addEventListener('shopify:section:load', boot);
})(typeof window !== 'undefined' ? window : globalThis);

